import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f7fafc', padding: '24px' }}>
          <div style={{ textAlign: 'center', maxWidth: '480px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '8px', color: '#1a202c' }}>Something went wrong</h2>
            <p style={{ color: '#718096', fontSize: '14px', marginBottom: '16px' }}>
              An unexpected error occurred. Try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '8px 20px', background: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>
              Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre style={{ marginTop: '16px', textAlign: 'left', fontSize: '12px', color: '#e53e3e', background: '#fff5f5', padding: '12px', borderRadius: '6px', overflow: 'auto' }}>
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
